import { useEffect, useRef, useState } from 'react'
import CreateProductsStyle from './CreateProductsStyle'
import Button from '../../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi } from '../../../api'
import { get } from 'lodash'
import { BsEyeFill } from 'react-icons/bs'
import time from '../../../helpers/time'
import {
	ErrorModal,
	SuccessModal,
	WarningModal,
	CreateUser,
} from '../../../components/Modal'
import { useDispatch, useSelector } from 'react-redux'
import ChangeDate from './ChangeDate'
import { main } from '../../../store/slices'
import Layout from '../../../components/Layout'
import moment from 'moment'
import { roundCurrency } from '../../../utils'
import ConfirmModal from '../../../components/ComfirmModal'
import customMainApi from '../../../api/index'
import _ from 'lodash'
import CreateIcloudModal from '../../../components/Modal/CreateIcloud'
import AddImage from '../../../components/AddNewImage/index'
import ClientInfoModal from '../../../components/Modal/ClientInfo'
import { AutoComplete, Select, Input, Table, Tooltip } from 'antd'
import { formatNumberWithIntl } from '../../../utils/formatNumber'
import { removeSpaces } from '../../../utils/removeSpaces'

const CreateProducts = () => {
	const initialDocLine = {
		itemCode: '',
		itemName: '',
		item: '',
		quantity: 0,
		serialNumbers: [],
		serialNumbersText: '',
		color: '',
		condition: '',
		memory: '',
		currentPrice: 0,
		icloudCode: '',
		icloudName: '',
		shopfrontPrice: 0,
		percent: 1, //100% degani
		unitPrice: 0,
	}
	const { setDate } = main.actions
	const { getMe } = useSelector((state) => state.main)

	const navigate = useNavigate()
	const dispatch = useDispatch()

	const changeDateRef = useRef()
	const errorRef = useRef()
	const infoNotEndedRef = useRef()
	const successModalRef = useRef()
	const succesCreateUserRef = useRef()
	const createUserRef = useRef()
	const createIcloud = useRef()

	const [icloudData, setIcloudData] = useState([])
	const [customerData, setCustomerData] = useState([])
	const [productNameData, setProductNameData] = useState([])
	const [seriaNumberData, setSeriaNumberData] = useState([])
	const [tableData, setTableData] = useState([])
	const [simpleMonthData, setsimpleMonthData] = useState([])
	const [vipMonthData] = useState([])
	const [garantData, setGarantData] = useState([])
	const [owner, setOwner] = useState('Icomfort')
	const [garant, setGarant] = useState('')
	const [searchGarant, setSearchGarant] = useState('')
	const [searchCustomer, setSearchCustomer] = useState('')
	const [garantCardCode, setGarantCardCode] = useState('')
	const [month, setMonth] = useState('')
	const [monthB2B, setMonthB2B] = useState('')
	const [customer, setCustomer] = useState('')
	const [userCardCode, setUserCardCode] = useState('')
	const [dateIndex, setDateIndex] = useState(0)
	const [viewData, setViewData] = useState({})
	const [firstPayingMoney, setFirstPayingMoney] = useState(0)
	const [isCalculated, setIsCalculated] = useState(false)
	const [isMainLoading, setIsMainLoading] = useState(false)
	const [comment, setComment] = useState('')
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')
	const [salesPerson, setSalesPerson] = useState([])
	const [slp, setSlp] = useState('')
	const [loadingIcloud, setLoadingIcloud] = useState(false)
	const [amount, setAmount] = useState(0)
	const [userFields, setUserFields] = useState([])
	const [isClientInfoModalOpen, setIsClientInfoModalOpen] = useState(false)
	const [docLines, setDocLines] = useState([initialDocLine])
	const [bpLoading, setBpLoading] = useState(false)
	const [itemLoading, setItemLoading] = useState(false)
	const [monthLoading, setMonthLoading] = useState(false)
	const [sysNumberLoading, setSysNumberLoading] = useState(false)
	const [icloudName, setIcloudName] = useState('')

	const toWarehouse =
		get(getMe, 'Department2.Name', '') !== 'Boshqaruv'
			? get(getMe, 'U_Warehouse', '')
			: ''

	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])

	useEffect(() => {
		searchUser(searchCustomer, 'customer')
	}, [searchCustomer])

	useEffect(() => {
		searchUser(searchGarant, 'garant')
	}, [searchGarant])

	useEffect(() => {
		getSimpleMonth()
		getSalesPersons()
		userFieldsFn()
	}, [])

	const handleOpenModal = () => {
		const lines = docLines.flatMap((v) => {
			const sum = calculateLinesPrice(v)
			return [
				{
					name: '------------------------------------------',
					// value: '--------------',
				},
				{
					name: 'Товар:',
					value: v.itemName,
				},
				{
					name: 'Серийный номер:',
					value: v?.serialNumbers.IntrSerial,
				},
				{
					name: 'Цена:',
					value: formatNumberWithIntl(sum),
				},
			]
		})

		setConfirmationMessage([
			{
				name: 'Клиент:',
				value: customer,
			},
			{
				name: 'Товар:',
				value: docLines[0].itemName,
			},

			{
				name: 'Кому принадлежит:',
				value: owner,
			},
			{
				name: 'Менеджер продаж',
				value:
					salesPerson.find((v) => v.SalesEmployeeCode === Number(slp))
						?.SalesEmployeeName || 'Менеджер не найден',
			},

			{
				name: 'Аккаунт защиты:',
				value: icloudName,
			},
			{
				name: 'Comment:',
				value: comment,
			},
			{
				name: 'ГАРАНТ:',
				value: garant,
			},
			{
				name: 'График оплаты:',
				value: JSON.stringify(
					tableData.map((v) => ({
						Сумма: v.price,
						'Дата платежа': v.date,
					})),
				),
			},
			...lines,
		])
		setShowModal(true)
	}

	const searchIcloud = (a = '') => {
		setLoadingIcloud(true)

		api
			.get(
				`Security?$select=Code,Name,U_Whichtelephone,U_Password,U_Status,U_TypeAccount&$orderby=Code desc&$filter=U_Status eq 'bosh' and (contains(Name, '${a}') or contains(Code, '${a}'))`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setIcloudData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setLoadingIcloud(false)
			})
	}

	const getSimpleMonth = () => {
		setMonthLoading(true)
		api
			.get('U_INSTCONFBASIC')
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setsimpleMonthData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить данные, попробуйте еще раз.',
					),
				)
			})
			.finally(() => {
				setMonthLoading(false)
			})
	}

	const searchUser = (a = '', who) => {
		setBpLoading(true)
		api
			.get(
				`BusinessPartners?$select=CardCode,CardName,Address,U_Telephone,U_Gender,U_PS,BPAddresses&$filter=CardType eq 'cCustomer' and Frozen eq 'tNO' and (contains(CardName,'${encodeURIComponent(a)}') or contains(CardCode,'${encodeURIComponent(a)}') or contains(U_Telephone,'${encodeURIComponent(a)}'))`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				who === 'garant' ? setGarantData(resData) : setCustomerData(resData)
			})
			.catch((err) => {
				console.error(`${who} API Error:`, err) // Debug error
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response?.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setBpLoading(false)
			})
	}

	const searchProduct = (a = '') => {
		setItemLoading(true)
		customFuncsApi
			.get(
				`/xsSql/getItemsByWarehouse?${get(getMe, 'Department2.Name', '') !== 'Boshqaruv' ? `whsCode='${get(getMe, 'U_Warehouse', '')}'&` : `whsCode='${toWarehouse}'&`}ItemName=${a}&isOnHand=true`,
			)
			.then((res) => {
				const resData = get(res.data, 'value', [])
				setProductNameData(resData)
				// if (resData.length < 2) {
				// 	getSameSerialNumnber(a?.split(', ')[1])
				// 	setProductCode(a.split(', ')[1])
				// }
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setItemLoading(false)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getSameSerialNumnber = (num) => {
		setSysNumberLoading(true)
		customFuncsApi
			.get(
				`/xsSql/getItemSerialsByWhsCode?ItemCode='${num}'${get(getMe, 'Department2.Name', '') !== 'Boshqaruv' ? `&WhsCode='${get(getMe, 'U_Warehouse', '')}'` : `&WhsCode='${toWarehouse}'`}`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=1000000',
					},
				},
			)
			.then((res) => {
				const resData = get(res.data, 'value', [])
				setSeriaNumberData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
			.finally(() => {
				setSysNumberLoading(false)
			})
	}

	const getSalesPersons = () => {
		api
			.get(`SalesPersons?$filter=Active eq 'tYES'`, {
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setSalesPerson(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	const getOtherInformationsfromSerialNumber = (num) => {
		setSysNumberLoading(true)
		customFuncsApi
			.get(
				`/xsSql/getItemsByWarehouse?${get(getMe, 'Department2.Name', '') !== 'Boshqaruv' ? `whsCode='${get(getMe, 'U_Warehouse', '')}'` : `whsCode='${toWarehouse}'`}&IntrSerial='${num}'&isOnHand=true`,
			)

			.then((res) => {
				const resData = get(res.data, 'value', [])
				setProductNameData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setSysNumberLoading(false)
			})
	}

	const addTable = () => {
		if (month.length > 0 || monthB2B.length > 0) {
			let monthNumber = monthB2B.length > 0 ? monthB2B : month
			monthNumber = Number(monthNumber.split(' oy')[0]) + 1

			setTableData([])

			for (let i = 0; i < monthNumber; i++) {
				let nextMonth = moment().clone().add(i, 'months')
				setTableData((pr) => [
					...pr,
					{
						date: nextMonth.format('YYYY-MM-DD'),
						price: 0,
						price2: 0,
					},
				])
			}
			setIsCalculated(true)
		} else {
			infoNotEndedRef.current?.open()
		}
	}

	useEffect(() => {
		if (month.length > 0 || monthB2B.length > 0) {
			addTable()
		}
	}, [month, monthB2B])

	const ditributeMoney = (money) => {
		setFirstPayingMoney(Number(money))
		let protsent = monthB2B.length > 0 ? monthB2B : month
		let splitProsent = protsent.split(' oy')

		let whichType = monthB2B.length > 0 ? vipMonthData : simpleMonthData
		protsent =
			1 +
			Number(
				whichType.find((item) => item.U_Months == splitProsent[0])?.U_Percent,
			) /
				100

		const priceTotal = docLines.reduce((acc, item) => {
			return acc + +item.shopfrontPrice
		}, 0)

		let sameNumber = roundCurrency(
			(Number(priceTotal) - Number(money)) * protsent,
		)
		console.log('docLines[i].currentPrice', priceTotal, money, protsent)

		let monthMoney = roundCurrency(+sameNumber / (tableData.length - 1))

		let b = roundCurrency(+sameNumber + Number(money))
		console.log('sameNumber', sameNumber)
		console.log('money', money)
		console.log('monthMoney', monthMoney)
		console.log('persent', protsent)
		console.log('b', b)
		setAmount(b)

		// if (Number(money) > 0 && Number(money) < Number(amount)) {
		for (let i = 0; i < tableData.length; i++) {
			if (i !== 0) {
				let aa = [...tableData]
				aa[i].price = monthMoney
				setTableData(aa)
				console.log('aa[i].price', aa[i].price)
			} else {
				let aa = [...tableData]
				aa[0].price = money
				setTableData(aa)
				console.log('aa[0].price', aa[0].price)
			}
		}
		// }
	}

	const checkU_WHSCode = () => {
		if (get(getMe, 'Department2.Name', '') !== 'Boshqaruv') {
			if (get(getMe, 'U_Warehouse', null) === null) {
				alert('Foydalanuvchiga ombor biriktirilmagan')
			} else {
				createOrder()
			}
		} else {
			createOrder()
		}
	}

	const createOrder = () => {
		const photoId = imageList
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')
		const nowDays = new Date()
		let whichType = monthB2B.length > 0 ? vipMonthData : simpleMonthData

		let protsent = monthB2B.length > 0 ? monthB2B : month || ''
		let splitProsent = protsent.split(' oy')

		protsent =
			1 +
			Number(
				whichType.find((item) => item?.U_Months == splitProsent[0])?.U_Percent,
			) /
				100
		setIsMainLoading(true)

		const dataT = tableData.map((v) => {
			return {
				Total: +v.price,
				DueDate: v.date,
			}
		})

		console.log('docLines', docLines)

		const documentLines = docLines.map((v) => {
			const linePrice = formatNumberWithIntl(calculateLinesPrice(v))
			return {
				ItemCode: v.itemCode,
				SerialNumbers: [
					{
						InternalSerialNumber: v?.serialNumbers.IntrSerial,
						SystemSerialNumber: v?.serialNumbers.SysNumber,
					},
				],
				Quantity: 1,
				UnitPrice: +removeSpaces(linePrice),
				WarehouseCode: get(getMe, 'U_Warehouse', ''),
			}
		})

		let body = {
			CardCode: userCardCode,
			DocDate: time.to(nowDays, 'YYYY-MM-DD'),
			U_Owner: owner,
			U_Guarantor: garantCardCode,
			U_Icloud: icloudName,
			Comments: comment,
			U_PhotoID: photoId,
			U_TypeInvoice: 'Nasiya',
			U_FirstPayment: firstPayingMoney,
			SalesPersonCode: Number(slp),
			// DocTotal: +amount,
			DocumentLines: documentLines,
		}
		Object.assign(body, { DocumentInstallments: dataT })
		api
			.post(`Invoices`, body)
			.then((res) => {
				const resData = JSON.parse(res.data)
				setViewData({
					...resData,
					CardName: get(resData, 'CardName', ''),
					DocEntry: get(resData, 'DocEntry', 0),
					CardCode: get(resData, 'CardCode', 0),
					DocumentLines: get(resData, 'DocumentLines', []),
				})
				// closeIcloud(icloudCode)
				successModalRef.current?.open('Заказ успешно создан')
			})
			.catch((err) => {
				setIsMainLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const changeMainPrice = (data) => {
		const totalPrices = data.reduce(
			(acc, item) => acc + Number(item.shopfrontPrice),
			0,
		)
		let mainPrice = Number(totalPrices)
		setAmount(totalPrices)

		console.log(
			'mainPrice',
			mainPrice,
			firstPayingMoney,
			Number(tableData.length) - 1,
			(mainPrice - firstPayingMoney) / (Number(tableData.length) - 1),
		)

		let A = (mainPrice - firstPayingMoney) / (Number(tableData.length) - 1)

		for (let i = 0; i < tableData.length; i++) {
			if (i !== 0) {
				let aa = [...tableData]
				aa[i].price = A
				setTableData(aa)
			} else {
				let aa = [...tableData]
				aa[0].price = firstPayingMoney
				setTableData(aa)
			}
		}
	}

	const changeDate = (v) => {
		let exampleDate = [...tableData]
		let endOfMonth = moment(v).endOf('month').format('DD')
		let day = moment(v).format('DD')
		let isEnd = day === endOfMonth

		for (let i = 0; i < exampleDate.length; i++) {
			let nextMonth = moment().clone().add(i, 'months').format('YYYY-MM-DD')
			let selectedDay = null
			if (isEnd) {
				selectedDay = moment(nextMonth).endOf('month').format('YYYY-MM-DD')
			} else {
				if (
					moment(nextMonth).format('MM') === '02' &&
					day > moment(nextMonth).endOf('month').format('DD')
				) {
					selectedDay = moment(nextMonth).endOf('month').format('YYYY-MM-DD')
					console.log(true)
					console.log(selectedDay)
				} else {
					selectedDay = nextMonth.slice(0, 8) + day
				}
			}

			if (dateIndex <= i) {
				exampleDate[i].date = selectedDay
			}
		}
		setTableData(exampleDate)
		changeDateRef.current?.close()
	}

	const openChangeDate = (date, i) => {
		dispatch(setDate(date))
		changeDateRef.current?.open()
		setDateIndex(i)
	}

	const handleChangeValues = (v) => {
		let aa = [...tableData]
		let total = 0
		for (let i = 1; i < tableData.length; i++) {
			aa[i].price = v
			total += Number(v)
		}
		total += +firstPayingMoney
		setTableData(aa)

		setAmount(total)
	}

	const calculateLinesPrice = (record) => {
		const totalPrice = docLines.reduce((a, b) => a + +b.shopfrontPrice, 0)
		const persentPrice = +amount - +totalPrice
		const sum = +record.shopfrontPrice + +persentPrice * +record.percent
		return sum || 0
	}

	const debouncedSearchIcloud = _.debounce((value) => searchIcloud(value), 500)
	const debouncedSearchItem = _.debounce((value) => searchProduct(value), 500)

	const handleBusinessPartner = _.debounce((setValue, value) => {
		setValue(value)
	}, 500)

	const handleGarantSearch = _.debounce((setValue, value) => {
		setValue(value)
	}, 1000)

	const customersOptions = customerData.map((v) => ({
		label: (
			<Tooltip title={`${v.CardName}, ${v.CardCode}`}>
				<span className="text-wrap">{`${v.CardName}, ${v.CardCode}`}</span>
			</Tooltip>
		),
		value: v.CardCode,
		cardName: v.CardName,
		cardCode: v.CardCode,
	}))

	const garantOptions = garantData.map((v) => ({
		label: (
			<Tooltip title={`${v.CardName}, ${v.CardCode}`}>
				<span className="text-wrap">{`${v.CardName}, ${v.CardCode}`}</span>
			</Tooltip>
		),
		value: v.CardCode,
		cardName: v.CardName,
		cardCode: v.CardCode,
	}))

	const salesPersonOptions = salesPerson.map((v) => ({
		label: (
			<Tooltip title={`${v.SalesEmployeeName}`}>
				<span className="text-wrap">{`${v.SalesEmployeeName}`}</span>
			</Tooltip>
		),
		value: v.SalesEmployeeCode,
		salesEmployeeName: v.SalesEmployeeName,
		salesEmployeeCode: v.SalesEmployeeCode,
	}))

	const ownerOptions = userFields
		?.find((item) => item.Name === 'Owner')
		?.ValidValuesMD.map((value) => ({
			label: (
				<Tooltip title={`${value.Description}`}>
					<span className="text-wrap">{`${value.Description}`}</span>
				</Tooltip>
			),
			value: value.Value,
			name: value.Description,
			code: value.Value,
		}))

	const itemsOptions = productNameData.map((v) => ({
		label: (
			<Tooltip title={`${v.ItemName}, ${v.ItemCode}`}>
				<span className="text-wrap">{`${v.ItemName}, ${v.ItemCode}`}</span>
			</Tooltip>
		),
		key: `${v.ItemName}, ${v.ItemCode} , ${v.WhsCode}`,
		value: v.ItemCode,
		itemName: v.ItemName,
		itemCode: v.ItemCode,
		color: v.U_Color,
		condition: v.U_Condition,
		memory: v.U_Memory,
		whsCode: v.WhsCode,
		currentPrice: v.CurrentPrice,
		shopfrontPrice: v.U_ShopfrontPrice,
	}))

	const serialNumberOptions = seriaNumberData.map((v, i) => ({
		label: `${i + 1})${v.IntrSerial}`,
		value: v.IntrSerial,
		currentPrice: v.CostTotal,
		shopfrontPrice: v.U_ShopfrontPrice,
		data: v,
	}))

	const icloudOptions = icloudData.map((v, i) => ({
		label: `${v.Name}`,
		value: v.Code,
	}))

	const simpleMonthOptions = simpleMonthData.map((v, i) => ({
		label: `${v.U_Months} oy`,
		value: `${v.U_Months} oy`,
		key: i,
	}))

	const columns = [
		{
			title: 'Товар',
			dataIndex: 'item',
			key: 'item',
			render: (val, record, index) => (
				<AutoComplete
					className="w-full"
					value={val}
					options={itemsOptions}
					loading={itemLoading}
					onChange={(val, label) => {
						debouncedSearchItem(val)
						let docLinesData = [...docLines]
						docLinesData[index].item = val
						if (val === '') {
							docLinesData[index].itemCode = ''
							docLinesData[index].itemName = ''
							docLinesData[index].color = ''
							docLinesData[index].condition = ''
							docLinesData[index].memory = ''
							docLinesData[index].currentPrice = ''
						}
						setDocLines(docLinesData)
					}}
					onSelect={(val, label) => {
						console.log(val, label)
						let docLinesData = [...docLines]
						docLinesData[index].itemCode = val
						docLinesData[index].itemName = label.itemName
						docLinesData[index].color = label.color
						docLinesData[index].condition = label.condition
						docLinesData[index].memory = label.memory
						docLinesData[index].item = `${label.itemName}, ${label.itemCode}`
						setDocLines(docLinesData)
						getSameSerialNumnber(val)
					}}
				/>
			),
			width: 300,
		},
		{
			title: 'Cерийный номер',
			dataIndex: 'serialNumbersText',
			key: 'serialNumbersText',
			render: (val, record, index) => (
				<AutoComplete
					value={val}
					options={serialNumberOptions}
					className="w-full"
					loading={sysNumberLoading}
					onChange={(val, label) => {
						let docLinesData = [...docLines]
						docLinesData[index].serialNumbersText = val
						if (val === '') {
							docLinesData[index].serialNumbers = []
							docLinesData[index].currentPrice = ''
						}
						setDocLines(docLinesData)
						getOtherInformationsfromSerialNumber(val)
					}}
					disabled={!record.itemCode || !userCardCode}
					onSelect={(val, label) => {
						let docLinesData = [...docLines]
						docLinesData[index].serialNumbersText = label.label
						docLinesData[index].serialNumbers = label.data
						docLinesData[index].currentPrice = label.currentPrice
						docLinesData[index].shopfrontPrice = label.shopfrontPrice || 0
						setAmount((prev) => prev + (label.shopfrontPrice || 0))
						setDocLines(docLinesData)
						ditributeMoney(firstPayingMoney)
					}}
				/>
			),

			width: 200,
		},
		{
			title: 'Цвет',
			dataIndex: 'color',
			key: 'color',
			width: 150,
		},
		{
			title: 'Состояние',
			dataIndex: 'condition',
			key: 'condition',
			width: 150,
		},
		{
			title: 'Текущая цена',
			dataIndex: 'currentPrice',
			key: 'currentPrice',
			render: (val, record, index) => <span>{formatNumberWithIntl(val)}</span>,
		},
		{
			title: 'Цена продажи',
			dataIndex: 'shopfrontPrice',
			key: 'shopfrontPrice',
			width: 150,
			render: (val, record, index) => (
				<Input
					className="w-full"
					type="number"
					onWheel={(e) => e.target.blur()}
					value={val}
					disabled={
						!record.itemCode ||
						!userCardCode ||
						(!month && !monthB2B) ||
						record.serialNumbers.length === 0
					}
					onChange={(e) => {
						let docLinesData = [...docLines]
						docLinesData[index].shopfrontPrice = e.target.value
						const totalPrice = docLinesData.reduce(
							(a, b) => a + +b.shopfrontPrice,
							0,
						)
						for (let i = 0; i < docLinesData.length; i++) {
							docLinesData[i].percent = +(
								docLinesData[i].shopfrontPrice / totalPrice
							)
						}
						console.log('docLinesData', docLinesData)
						setDocLines(docLinesData)
						ditributeMoney(firstPayingMoney)
					}}
				/>
			),
		},
		{
			title: 'Цена с учетом рассрочки',
			dataIndex: 'priceWithPercent',
			key: 'priceWithPercent',
			render: (val, record, index) => {
				const sum = calculateLinesPrice(record)
				return <span>{formatNumberWithIntl(sum)}</span>
			},
		},

		{
			title: 'Actions',
			key: 'action',
			render: (text, record, index) => (
				<div className="flex gap-2">
					<button
						className="bg-[#0A4D68] text-white w-8 h-8 rounded-md"
						onClick={() => {
							let docLinesData = [...docLines]
							docLinesData.push(initialDocLine)
							setDocLines(docLinesData)
						}}
					>
						+
					</button>
					{docLines?.length > 1 && (
						<button
							className="bg-red-500 text-white w-8 h-8 rounded-md"
							onClick={() => {
								let docLinesData = [...docLines]
								docLinesData.splice(index, 1)
								setDocLines(docLinesData)
							}}
						>
							-
						</button>
					)}
				</div>
			),
		},
	]

	return (
		<Layout>
			<CreateProductsStyle>
				<div className="container">
					<div className=" w-full flex flex-col sm:flex-row  gap-5">
						<div className="flex flex-col gap-5 w-full overflow-x-auto">
							<div className="flex items-start gap-5 flex-wrap">
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">Клиент</p>
									<div className="flex gap-2 items-center w-full">
										<AutoComplete
											className="h-8 w-[300px]"
											options={customersOptions}
											value={customer}
											loading={bpLoading}
											onChange={(v) => {
												setCustomer(v)
												handleBusinessPartner(setSearchCustomer, v)
											}}
											onSelect={(v, label) => {
												setUserCardCode(v)
												setCustomer(`${label.cardName}, ${label.cardCode}`)
											}}
										/>
										<button
											className="bg-[#0A4D68] text-white w-10 h-8 rounded-md"
											onClick={() => createUserRef.current?.open()}
										>
											+
										</button>
										<button
											className="bg-[#0A4D68] text-white w-10 h-8 rounded-md flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
											onClick={() => setIsClientInfoModalOpen(true)}
											disabled={!userCardCode || !customer}
										>
											<BsEyeFill />
										</button>
									</div>
								</div>
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">ГАРАНТ</p>
									<div className="flex gap-2 items-center w-full">
										<AutoComplete
											className="h-8 w-[300px]"
											options={garantOptions}
											value={garant}
											onChange={(v) => {
												setGarant(v)
												handleGarantSearch(setSearchGarant, v)
											}}
											onSelect={(v, label) => {
												setGarantCardCode(v)
												setGarant(`${label.cardName}, ${label.cardCode}`)
											}}
										/>
										<button
											className="bg-[#0A4D68] text-white w-10 h-8 rounded-md"
											onClick={() => createUserRef.current?.open()}
										>
											+
										</button>
									</div>
								</div>
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">Кому принадлежит</p>
									<Select
										onChange={(v) => setOwner(v)}
										value={owner}
										options={ownerOptions}
										className="h-8 w-[200px]"
										placeholder="Кому принадлежит"
										showSearch
									/>
								</div>
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">Менеджер продаж</p>
									<Select
										onChange={(v) => setSlp(v)}
										value={slp}
										options={salesPersonOptions}
										className="h-8 w-[200px]"
										placeholder="Менеджер продаж"
										showSearch
									/>
									{!slp && (
										<p className="text-red-500 text-sm w-[200px]">
											Пожалуйста, выберите Менеджер. Это обязательное поле.
										</p>
									)}
								</div>
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">Аккаунт защиты</p>
									<div className="flex gap-2">
										<AutoComplete
											value={icloudName}
											options={icloudOptions}
											className="w-[200px] h-8"
											loading={loadingIcloud}
											onChange={(val, label) => {
												setIcloudName(val)

												debouncedSearchIcloud(val)
											}}
											onSelect={(val, label) => {
												setIcloudName(label.label)
											}}
										/>
										<div className="w-8">
											<button
												className="bg-[#0A4D68] text-white w-8 h-8 rounded-md"
												onClick={() => createIcloud.current?.open()}
											>
												+
											</button>
										</div>
									</div>
								</div>
							</div>
							<div className="mt-5 overflow-x-auto">
								<Table
									dataSource={docLines}
									columns={columns}
									pagination={false}
									scroll={{ x: 'max-content' }}
									bordered
									className=" border-[1px] border-gray-500 "
								/>
								<div className="mt-10 flex justify-between">
									<div className="flex flex-col gap-2 items-start">
										<div className="flex gap-10">
											<div className="flex flex-col gap-2 items-start ">
												<p className="font-semibold text-sm">Месяц</p>
												<Select
													onChange={(v) => {
														setMonth(v)
														setMonthB2B('')
														ditributeMoney(firstPayingMoney)
													}}
													className="w-[200px]"
													value={month}
													loading={monthLoading}
													options={simpleMonthOptions}
												/>
											</div>
										</div>
										<div>
											<div className="flex flex-col gap-2 items-start mt-4">
												<p className="font-semibold text-sm">Общая сумма</p>
												<Input
													value={amount || 0}
													onChange={(e) => changeMainPrice()}
													disabled={true}
												/>
											</div>
										</div>
									</div>
									<div className="flex flex-col gap-2 items-start ">
										<p className="font-semibold text-sm">Комментарии</p>
										<Input.TextArea
											value={comment}
											onChange={(e) => setComment(e.target.value)}
											className="w-[300px]"
											placeholder="Комментарий"
											rows={3}
										/>
									</div>
								</div>
								<AddImage imageList={imageList} setImageList={setImageList} />
							</div>
						</div>
						<div className="w-full sm:w-1/3 border-l-[1px] border-[#DFE2E9] pl-5">
							<div className="w-full">
								<div className="center mb-4">
									<Button onClick={addTable}>Расчет</Button>
								</div>

								{isCalculated ? (
									<div className="overflow-y-auto mb-8">
										<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
											<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
												<tr>
													<th scope="col" className="px-6 py-4">
														N
													</th>
													<th scope="col" className="px-6 py-4">
														Дата
													</th>
													<th scope="col" className="px-6 py-4">
														Оплата
													</th>
												</tr>
											</thead>
											<tbody>
												{tableData.map((v, i) => {
													return (
														<tr
															className="bg-white border-b  hover:bg-gray-50 "
															key={i}
														>
															<td className="px-6 py-4 font-medium text-gray-900 ">
																{i}
															</td>
															<td
																onClick={() => openChangeDate(v.date, i)}
																className="px-6 py-4 whitespace-nowrap"
															>
																{v.date}
															</td>
															<td className="px-6 py-4">
																{i === 0 && (
																	<input
																		type="number"
																		className={
																			'border-[1px] border-[#DFE2E9"] p-2 rounded-md min-w-20 w-full'
																		}
																		onChange={(v) => {
																			ditributeMoney(v.target.value)
																		}}
																		onWheel={(e) => e.target.blur()}
																	/>
																)}
																{i === 1 && (
																	<input
																		type="number"
																		className={
																			'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
																		}
																		value={v.price}
																		onChange={(v) =>
																			handleChangeValues(v.target.value)
																		}
																		onWheel={(e) => e.target.blur()}
																	/>
																)}
																{i !== 0 &&
																	i !== 1 &&
																	Number(roundCurrency(v.price))}
															</td>
														</tr>
													)
												})}
											</tbody>
										</table>
									</div>
								) : null}
							</div>
						</div>
					</div>
					<div className="flex gap-3 mt-8 justify-end w-full">
						<Button
							btnStyle={{ backgroundColor: 'red' }}
							onClick={() => navigate('/sales')}
						>
							Назад
						</Button>
						<Button
							onClick={handleOpenModal}
							disabled={slp === ''}
							isLoading={isMainLoading}
						>
							Создать
						</Button>
					</div>
				</div>
			</CreateProductsStyle>
			<>
				<CreateUser getRef={(r) => (createUserRef.current = r)} />
				<ErrorModal
					getRef={(r) => (errorRef.current = r)}
					onConfirm={() => {
						setIsMainLoading(false)
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						succesCreateUserRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successModalRef.current = r
					}}
					onConfirm={() => navigate('/viewItem', { state: viewData })}
				/>

				<ChangeDate
					getRef={(r) => {
						changeDateRef.current = r
					}}
					onConfirm={(v) => changeDate(v)}
				/>

				<WarningModal
					getRef={(ref) => {
						infoNotEndedRef.current = ref
					}}
				/>
				<CreateIcloudModal
					getRef={(r) => (createIcloud.current = r)}
					onConfirm={() => {
						succesCreateUserRef.current?.open('Аккаунт защиты успешно создан')
					}}
				/>
				<ConfirmModal
					show={showModal}
					data={confirmationMessage}
					onConfirm={() => {
						setShowModal(false)
						checkU_WHSCode()
					}}
					onCancel={() => {
						setShowModal(false)
					}}
				/>
				<ClientInfoModal
					isOpen={isClientInfoModalOpen}
					onClose={() => setIsClientInfoModalOpen(false)}
					clientCode={userCardCode}
				/>
			</>
		</Layout>
	)
}

export default CreateProducts
